import React, { SFC } from 'react';
import classNames from 'classnames';

import styles from './user-return.module.styl';
import { getTranslator } from '../../../helpers/i18n';
import { IllustrationMerchantCenter } from '@grpn/mx-components';

const translate = getTranslator('_success._userReturn');

const Return: SFC = () => (
  <div className={classNames('mx-main', styles.container)}>
    <h2>{translate('title')}</h2>
    <div className={styles.topIconContainer}>
      <IllustrationMerchantCenter height={64} widht={64} />
    </div>
    <br />
    <p>{translate('subtitle')}</p>
    <br />
    <div className={styles.loginButtonContainer}>
      <button
        onClick={() =>
          (window.location.href = `${window.location.protocol}//${window.location.host}/merchant/center/login`)
        }
        className={classNames(
          'button-primary button-cta submit btn btn-buy next',
          styles.loginButton,
        )}
      >
        {translate('loginButtonText')}
      </button>
    </div>
  </div>
);

export default Return;
